import * as React from "react";
import { createTheme, ThemeProvider } from "@mui/material";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Home from "./Pages/Home";
import Players from "./Pages/Players";
import PlayerStatsSMP from "./Pages/PlayerStatsSMP";
import PlayerStatsSMPTwoYear from "./Pages/PlayerStatsSMPTwoYear";
import PlayerStatsHardcore from "./Pages/PlayerStatsHardcore";
import PlayerStatsPvP from "./Pages/PlayerStatsPvP";
import VillagerMarkets from "./Pages/VillagerMarkets";
import Markets from "./Pages/Markets";
import Rules from "./Pages/Rules";
import Guide from "./Pages/Guide";
import GuideHardcore from "./Pages/GuideHardcore";
import Contact from "./Pages/Contact";
import Map from "./Pages/Map";
import FishSubmission from "./Pages/FishSubmission";
import Vote from "./Pages/Vote";
import MonthlyStats from "./Pages/MonthlyStats";
import ResponsiveMenuBar from "./Components/ResponsiveMenuBar";
import Footer from "./Components/Footer";

const theme = createTheme({
  palette: {
    header: {
      main: "#215c9c", // Override success color
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <Router>
        <ResponsiveMenuBar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/map" element={<Map />} />
          <Route path="/players" element={<Players />} />
          <Route path="/stats-smp" element={<PlayerStatsSMP />} />
          <Route path="/stats-two-year" element={<PlayerStatsSMPTwoYear />} />
          <Route path="/stats-hardcore" element={<PlayerStatsHardcore />} />
          <Route path="/stats-pvp" element={<PlayerStatsPvP />} />
          <Route path="/villager-markets" element={<VillagerMarkets />} />
          <Route path="/markets" element={<Markets />} />
          <Route path="/rules" element={<Rules />} />
          <Route path="/guide" element={<Guide />} />
          <Route path="/guide-hardcore" element={<GuideHardcore />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/fish-submission" element={<FishSubmission />} />
          <Route path="/vote" element={<Vote />} />
          <Route path="/monthly-stats" element={<MonthlyStats />} />
        </Routes>
        <Footer />
      </Router>
    </ThemeProvider>
  );
}
export default App;
